import React, {useContext} from 'react';
import {TableWrapperContext} from './TableWrapper';
import {TrekerButton} from '../../pages/traffic/influence/bloggers/source/Treker/TrekerButton';
import {useResolvedThemeMode} from '../../hooks/useResolvedThemeMode';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

const BlankSheet = () => {
  const theme = useResolvedThemeMode();

  const {timeConfig, activatePreset, objectToQueryString} = useContext(TableWrapperContext);

  return (
    <>
      <OverlayTrigger
        delay={{hide: 450, show: 300}}
        placement='top'
        overlay={(props) => (
          <Tooltip className='fs-8' {...props}>
            Сброс
          </Tooltip>
        )}
      >
        <div>
          <TrekerButton
            svg={
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='15'
                height='16'
                fill='none'
                viewBox='0 0 15 16'
              >
                <g fill='#292D32'>
                  <path d='M14.667 3a1 1 0 0 0-1-1h-2.518a2.996 2.996 0 0 0-2.816-2h-2a2.996 2.996 0 0 0-2.816 2H1a1 1 0 0 0 0 2h.333v8.333A3.667 3.667 0 0 0 5 16h4.667a3.667 3.667 0 0 0 3.666-3.667V4h.334a1 1 0 0 0 1-1Zm-3.334 9.333c0 .92-.746 1.667-1.666 1.667H5c-.92 0-1.667-.746-1.667-1.667V4h8v8.333Z'></path>
                  <path d='M5.667 12a1 1 0 0 0 1-1V7a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1ZM9 12a1 1 0 0 0 1-1V7a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1Z'></path>
                </g>
              </svg>
            }
            style={{
              height: '40px',
              gap: '0',
              backgroundColor: theme === 'dark' ? 'rgba(27, 29, 35, 1)' : 'rgba(245, 246, 247, 1)',
            }}
            onClick={() => {
              activatePreset(objectToQueryString(timeConfig), true);
            }}
          />
        </div>
      </OverlayTrigger>
    </>
  );
};

export default BlankSheet;
